// Gets perceived brightness of hex colour using YIQ formula
export default function getHexBrightness(hex: string) {
  let hexNum = hex.replace(/^#/, '');

  if (hexNum.length === 3) {
    hexNum = hexNum
      .split('')
      .map((c: string) => c + c)
      .join('');
  }

  const r = parseInt(hexNum.substring(0, 2), 16);
  const g = parseInt(hexNum.substring(2, 4), 16);
  const b = parseInt(hexNum.substring(4, 6), 16);

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 128 ? 'light' : 'dark';
}
